import { put, call, select } from 'redux-saga/effects'
import { REQUEST_UPLOAD_TEMPLATE_START } from 'store/sagas'
import requestAddBoard from './requestAddBoard'
import sweetalert from 'sweetalert2'

export default function * requestAddBoardTemplateFromFile (action) {
  const { file, ...payload } = action.payload

  const onUpload = function * ({ fileId }) {
    try {
      yield requestAddBoard({
        ...action,
        payload: {
          isTemplate: true,
          template: { type: 'file', id: fileId },
          ...payload
        }
      })
    } catch (e) {
      const state = yield select()
      try {
        yield call(sweetalert, {
          text: state.kanbo.locale.messages['BOARD_ADD_NEW_TEMPLATE_FROM_FILE_ERROR'],
          type: 'error'
        })
      } catch (e) {} // eslint-disable-line no-empty
    }
  }

  yield put({
    type: REQUEST_UPLOAD_TEMPLATE_START,
    payload: {
      file,
      onUpload
    }
  })
}
